import React, { useEffect, useState } from "react";
import { useLocation, useNavigate } from "react-router-dom";
import DashboardNavbar from "../components/Navbar/navbar-dashboard";
import Footer from "../components/Footer/footer";
import './subscription.css';
import { FaCheckCircle } from 'react-icons/fa';
import styles from '../components/Navbar/ModernNavBarPureCSS.module.css';
import imageLogo from "../assets/images/LogoBuildStart03.png";

const SuccessPage = () =>
{
  const location = useLocation();
  const [businessId, setBusinessId] = useState("");
  const [email, setEmail] = useState("");
  const [priceId, setPriceId] = useState("");
  const [title, setTitle] = useState("");
  const navigate = useNavigate();

  useEffect(() =>
  {
    const searchParams = new URLSearchParams(location.search);
    const businessIdParam = searchParams.get("businessId");
    const emailParam = searchParams.get("email");
    const priceIdParam = searchParams.get("priceId");
    const titleParam = searchParams.get("title");

    setBusinessId(businessIdParam);
    setEmail(emailParam);
    setPriceId(priceIdParam);
    setTitle(titleParam);
  }, [location]);

  return (
    <>
 
      <nav className={`${styles.modern_navbar} `}>
        <div className={styles.modern_navbar_container}>
          <div className={styles.modern_navbar_logo}>
            <div className={styles.logo_icon}>
                        <img
            src={imageLogo}   // Replace with your logo image path
            alt="Build Start Logo"
            style={{ height: '35px', marginRight: '10px' }}  // Adjust size & spacing as needed
          />
            </div>
            <div className={styles.logo_text}>
              <span className={styles.logo_brand}>BuildStart</span>
                <span className={styles.logo_badge}>Professional</span>
            </div>
          </div>

	</div>
    </nav>

      <div className="success-page">
        <div className="success-content">
          <FaCheckCircle className="success-icon" />
          <h1>Subscription Successful!</h1>
          <p>Thank you for your purchase.</p>
          <div className="subscription-details">
            <p>You purchased the subscription: <strong>{title}</strong></p>
            <p><strong>Business ID:</strong> {businessId}</p>
            <p><strong>Email:</strong> {email}</p>
            <p><strong>Price ID:</strong> {priceId}</p>
          </div>
          <button className="back-button" onClick={() => (navigate('/subscription/subscribenew'))}>Go to Subscription Dashboard</button>
        </div>
      </div>
      <Footer />
    </>
  );
};

export default SuccessPage;